import { render } from "./loading.vue?vue&type=template&id=38cd19e5&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=38cd19e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd19e5"]])

export default __exports__